import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { Edges, VIEWPORTS } from '../../../styles/Grid/GridSizes';

export const containerMargin = css({});
